import { render } from "./district.vue?vue&type=template&id=60977132"
import script from "./district.vue?vue&type=script&lang=js"
export * from "./district.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__